
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { cloneDeep } from "lodash-es";
import moment from "moment";

import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiSelector.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import UserLocationsMultiselect from "@/components/autocompleteMultiselects/UserLocationsMultiselect.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputNew.vue";
import CustomButton from "@/components/new/buttons/CustomButton.vue";
import { Manager } from "@/generated/graphql";

import ManagerRadioButtonOptions from "@/entities/scheduler/ManagerRadioButtonOptions";
import RadioOption from "@/entities/RadioOption";
import managerViewFiltersTemplate from "@/data/filtersTemplates/scheduler/managerViewFIltersTemplate";
import ManagerAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ManagerAdditionalFilters";
import DateRange from "@/entities/scheduler/DateRange";
import CompanyScheduler from "@/views/scheduler/CompanyScheduler.vue";
import FormDatepicker from "@/components/form/FormDatepicker.vue";
import UIButton from "@/components/button/ui-button.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
@Component({
  components: {
    ManagersMultiselect,
    FormGroup,
    UserLocationsMultiselect,
    RadioButtonGroup,
    ProfileCountrySelect,
    RegionInput,
    UserCityMultiselect,
    CompanyScheduler,
    FormDatepicker,
    UIButton,
    CustomButton,
    ModalFullScreen,
  },
})
export default class ManagerAdvancedFilter extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly shouldClearFilters!: boolean;
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;

  filterFields: ManagerAdditionalFilters = cloneDeep(
    managerViewFiltersTemplate
  );
  managerProjects: Manager[] = [];
  rangeStart: Date = new Date();
  // rangeEnd: Date = moment(this.rangeStart).add(1, "M").toDate();
  rangeEnd: Date = this.rangeStart;


  created(): void {
    this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  }

  selectedFilters: any[] = [];

  dateRangeFilter: string = null;

  get numberOfAppliedFilters(): any {
    const appliedFiltersQuantity = {
      countries: this.filterFields.countries.length ? 1 : 0,
      states: this.filterFields.states.length ? 1 : 0,
      cities: this.filterFields.cities.length ? 1 : 0,
      users: this.filterFields.users.length ? 1 : 0,
      orderBy:
        this.filterFields.orderByChosenOption &&
          this.filterFields.orderByChosenOption !==
          ManagerRadioButtonOptions.MOST_PROJECTS_FIRST
          ? 1
          : 0,
    };

    return Object.values(appliedFiltersQuantity).reduce(
      (prevValue, curValue) => {
        return prevValue + curValue;
      },
      0
    );
  }

  get countriesNames(): string[] {
    return this.filterFields.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.filterFields.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.filterFields.cities.map((city) => city.name);
  }
  get getUsers(): string[] {
    return this.filterFields.users.map((title) => title.id);
    // return this.filterFields.names as any
  }
  handleDateRangeChange(date: DateRange) {
    this.rangeStart = date.startDate;
    this.rangeEnd = date.endDate;
    this.dateRangeFilter = `${moment(this.rangeStart).format(
      "MM/DD/YYYY"
    )} - ${moment(this.rangeEnd).format("MM/DD/YYYY")}`;
  }

  clearFilters(): void {
    this.filterFields = cloneDeep(managerViewFiltersTemplate);
    this.selectedFilters = [];
    //wip 3
    this.rangeStart = new Date();
    // this.rangeEnd=  moment(this.rangeStart).add(1, "M").toDate();
    this.rangeEnd = this.rangeStart;
  }

  closeModal(): void {
    this.$emit("close");
  }

  removeFilter(index: number): void {
    this.selectedFilters.splice(index, 1);
  }
  applyFilters(): void {
    this.$emit("apply-filters", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      rangeStart: this.rangeStart,
      rangeEnd: this.rangeEnd,
      users: this.getUsers,
      orderBy:
        this.filterFields.orderByChosenOption &&
          this.filterFields.orderByChosenOption !==
          ManagerRadioButtonOptions.MOST_PROJECTS_FIRST
          ? 1
          : 0,
    });
  }
  //create function to add filter to selected filters

  selectCountry(country: any): void {
    this.filterFields.countries.push(country[0]);
  }
  selectCity(city: any): void {
    this.filterFields.cities.push(city[0]);
  }
  selectRegion(region: any): void {
    this.filterFields.states.push(region[0]);
  }
}
